import { MediaTypes } from '~publish/legacy/constants'
import Modal from '../shared-components/modal/modal'
import styles from './css/MediaZoomBox.module.css'
import ImageDescriptionInput from './ImageDescriptionInput'
import {
  calculateAspectRatio,
  getHumanReadableSize,
} from '../utils/StringUtils'
import type { Gif, Image, Media, Video } from '../entities/factories'
import { Document } from '../entities/Document'
import { ImageIcon } from '@buffer-mono/popcorn'

function isVideo(media: Media): media is Video {
  return media.mediaType === MediaTypes.VIDEO
}

function isImage(media: Media): media is Image {
  return media.mediaType === MediaTypes.IMAGE
}

function isGif(media: Media): media is Gif {
  return media.mediaType === MediaTypes.GIF
}

interface MediaZoomBoxProps {
  media: Media
  showImageDescription: boolean
  altTextLimit: number
}
const MediaZoomBox = ({
  media,
  showImageDescription,
  altTextLimit = 1000,
}: MediaZoomBoxProps): JSX.Element => {
  const modalClassNames = {
    modal: styles.modalStyles,
    closeButton: styles.closeButton,
  }

  const aspectRatio =
    !Document.isDocument(media) &&
    media.width &&
    media.height &&
    calculateAspectRatio(media.width, media.height)

  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: (false | Element)[]; classNames:... Remove this comment to see the full error message
    <Modal classNames={modalClassNames}>
      {isGif(media) && (
        <div className={styles.mediaContainer}>
          <img className={styles.media} alt="" src={media.url} />
        </div>
      )}
      {isImage(media) && (
        <div className={styles.mediaContainer}>
          <picture className={styles.picture}>
            <img className={styles.media} alt="" src={media.url} />
            {aspectRatio && (
              <div className={styles.fileSize}>
                <ImageIcon size={12} />
                {aspectRatio}
              </div>
            )}
          </picture>
          {showImageDescription && (
            <ImageDescriptionInput
              mediaAttachment={media}
              altTextLimit={altTextLimit}
            />
          )}
        </div>
      )}
      {isVideo(media) && (
        <div className={styles.mediaContainer}>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            className={styles.media}
            poster={media.thumbnail}
            controls
            src={media.url}
          />
          <div className={styles.fileSize}>
            {getHumanReadableSize(media.size)}
            {aspectRatio && (
              <>
                {' | '}
                {aspectRatio}
              </>
            )}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default MediaZoomBox
